import '@babel/polyfill'
import 'focus-visible'
import 'whatwg-fetch'
import * as OfflinePluginRuntime from 'offline-plugin/runtime'

if (process.env.NODE_ENV === 'production') {
  OfflinePluginRuntime.install({
    onUpdateReady: () => {
      OfflinePluginRuntime.applyUpdate()
    },
    onUpdated: () => {
      const ev = new Event('UPDATE_READY')
      window.dispatchEvent(ev)
      window.localStorage.setItem('lastUpdateCheck', JSON.stringify(Date.now()))

      // purge after update incase of any changes to the apollo cache
      window.localStorage.removeItem('lastPurge')
    },
    onUpdateFailed: () => {
      console.error('Service Worker update failed')
    }
  })
}

// suppress react warnings we dont care about in development
if (process.env.NODE_ENV === 'development') {
  const errFn = console.error
  const ignore = [
    // Annoying material-ui errors (which are warnings) when a classes prop has keys that aren't used by that component
    // (we do this a lot intentionally, and there's no need to manually pull out class names for sake of the error)
    /provided to the classes prop is not implemented/,
    // thrown when a DOM element receives an unknown prop. this happens a lot with ...props, and is rarely consequential
    /Warning: React does not recognize the/
  ]
  console.error = (msg: string, ...args: string[]) => {
    if (ignore.every((re) => !msg?.match?.(re))) {
      errFn.call(console, msg, ...args)
    }
  }
}

import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'
import './index.css'

const render = (_Component: React.ComponentType) => {
  const container = document.getElementById('root')
  const root = createRoot(container)
  root.render(<App />)
}

render(App)
